"use client";

import React, { ReactNode, useEffect } from "react";
import styles from "./ModalManager.module.scss";
import Image from "next/image";
import assetLoader from "@utils/internalImageLoder";
import Text from "@components/atoms/Text";

type ModalManagerProps = {
  isOpen: boolean;
  onClose?: () => void;
  children: ReactNode;
  title?: string | ReactNode;
  showClose?: boolean;
  customClass?: string;
  overlayClass?: string;
  modalBodyClass?: string;
  preventScroll?: boolean;
  modalHeaderClass?: string;
};

export const ModalManager = ({
  isOpen,
  onClose,
  children,
  title,
  showClose = true,
  customClass = "",
  overlayClass = "",
  preventScroll = true,
  modalBodyClass = "",
  modalHeaderClass = "",
}: ModalManagerProps) => {
  useEffect(() => {
    if (isOpen && preventScroll) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen, preventScroll]);

  if (!isOpen) return null;

  return (
    <div className={`${styles.modalOverlay} ${overlayClass}`}>
      <div className={`${styles.modalContent} ${customClass}`}>
        {(title || showClose) && (
          <div className={`${styles.modalHeader} ${modalHeaderClass}`}>
            {title && <Text className={styles.modalTitle}>{title}</Text>}
            {showClose && (
              <Image
                src={`${assetLoader()}/icons/Close_Dark.svg`}
                alt="Close"
                width={24}
                loading="lazy"
                height={24}
                className={styles.modalClose}
                onClick={onClose}
              />
            )}
          </div>
        )}
        <div className={`${styles.modalBody} ${modalBodyClass}`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default ModalManager;
